import initGateway from '../../plugins/gateway/js/gateway.js';
import Gateway from '../../plugins/gateway/js/gateway.js';
import { sysTheme } from './variables.js';
import utils from '../common/utils.js';
import config from './config.js';
import websocket from '../common/websocket.js';
import { partPath } from './variables.js';

let { ajaxRequest, boxMessage, jumpToOtherSystem } = utils;

let { panelTipMsgUrl } = config;

/**
 * 必要缓存检测
 */
var checkTempKeys = [
  'ccTenantUserInfo',
  'configs',
  'headerClassify',
  'token',
  'expTime',
  'user_rights',
  'blocks',
];
for (var j = 0, len = checkTempKeys.length; j < len; j++) {
  var tempKey = checkTempKeys[j];
  var tempValue = window.localStorage.getItem(tempKey);
  if (!tempValue) {
    console.warn(tempKey + ' 缓存不存在');
    alert('缓存失效，确定后即将进行初始化流程');
    // 初始化之后重新跳转到这个页面
    window.location.href = `//${
      location.host
    }${partPath}?actualUrl=${encodeURIComponent(location.href)}`;
    break;
  }
}

var rightObj = {
  newsbigdata_hot_event_view: false,
  newsbigdata_hot_wechat_account_analysis: false,
  newsbigdata_hot_billboard: false,
  newsbigdata_hot_event_tracker: false,
  newsbigdata_hot_search: false,
  newsbigdata_hot_so_setting: false,
  newsbigdata_hot_word_analysis: false,
  newsbigdata_hot_word_exclude: false,
  newsbigdata_gateway_msg_notify: false,
  newsbigdata_clue_advance_search: false,
};
var rightErrorCode = 9990;
var limitErrorCode = 99993;
var hintType = 'warning';
var rightHintWords = '您无权访问此功能';
var detailRightHintWords = '您无权查看此类详情';
var limitHintWords = '您订阅的数量已超过套餐最大限制';
var headerSearchFunc;

$.ajaxSetup({
  cache: true,
});

$(function () {
  // 从缓存中获取权限信息
  var userRights = JSON.parse(window.localStorage.getItem('user_rights'));
  // 从缓存中获取版本标识
  var headerClassify = window.localStorage.getItem('headerClassify');
  // 从缓存中获取用户信息
  var userInfo = JSON.parse(window.localStorage.getItem('ccTenantUserInfo'));
  // 从缓存中获取地址信息
  var configs = JSON.parse(window.localStorage.getItem('configs'));
  // 从缓存中获取是否隐藏头部
  var hideHeader = JSON.parse(window.localStorage.getItem('hideHeader'));

  //获取缓存中的blocks，判断是否已购买热点发现、线索汇聚、传播分析
  var blocks = JSON.parse(window.localStorage.getItem('blocks'));
  var hasClueService = false,
    cluePath = void 0;
  var hasHotService = false,
    hotPath = void 0;
  var hasAnalysisService = false,
    analysisPath = void 0;
  $(blocks).each(function (i, v) {
    if (v.appId === 300) {
      hasHotService = true;
      hotPath = v.path;
    }
    if (v.appId === 400) {
      hasClueService = true;
      cluePath = v.path;
    }
    if (v.appId === 500) {
      hasAnalysisService = true;
      analysisPath = v.path;
    }
  });

  /*
   * 跳转到线索、热点、传播分析的loading页面，参数如下
   * system为clue、hot、analysis
   * hasService是否有此服务，true、false
   * path为跳转的loading路径
   * actualUrl为实际要跳转的地址，格式类似‘/hotEvents/hot-events-analyse.html’，
   * openNewWindow是否打开新窗口，true、false
   * */
  function jumpToOtherSystem(
    system,
    hasService,
    path,
    actualUrl,
    openNewWindow
  ) {
    //判断是否购买了线索、热点、传播分析，如果没有购买则提示用户
    if (system === 'clue' && !hasService) {
      boxMessage('warning', '您尚未购买线索汇聚，请联系管理员。');
      return;
    }
    if (system === 'hot' && !hasService) {
      boxMessage('warning', '您尚未购买热点发现，请联系管理员。');
      return;
    }

    if (system === 'analysis' && !hasService) {
      boxMessage('warning', '您尚未购买传播分析，请联系管理员。');
      return;
    }

    //根据不同的系统跳转不同的loading
    var jumpLoadingUrl = void 0;
    jumpLoadingUrl =
      '//' +
      window.location.host +
      path +
      '?actualUrl=' +
      encodeURIComponent(actualUrl);

    //根据是否新开页面来执行跳转
    if (openNewWindow) {
      window.open(jumpLoadingUrl);
    } else {
      window.location.href = jumpLoadingUrl;
    }
  }

  // 根据系统主题添加类样式
  $('body').addClass(sysTheme || 'default');

  // 权限控制逻辑，设置权限对象rightObj
  var rightControllFunc = function rightControllFunc() {
    //根据缓存中的权限判断关键权限rightObj中的值
    $(userRights).each(function (i, v) {
      for (var _j in rightObj) {
        if (v.indexOf(_j) !== -1) {
          rightObj[_j] = true;
        }
      }
    });

    // 如果有消息权限则显示该侧边栏（现在全部禁掉）
    rightObj['newsbigdata_gateway_msg_notify'] = false;
    if (rightObj['newsbigdata_gateway_msg_notify']) {
      $('#msgSetting').show();
    }
  };
  rightControllFunc();

  // 动态设置浏览器标签icon
  var shortcutFunc = function shortcutFunc() {
    var defaultShortcutImgUrl =
      '//cdn.bigdata.cloud.dayang.com.cn/common/favicon.ico';
    var shortcutImgUrl = configs.shortcutImgUrl || defaultShortcutImgUrl;
    $('head').append(
      '<link rel="shortcut icon" href="' + shortcutImgUrl + '" />'
    );
  };
  shortcutFunc();

  //左侧导航栏渲染逻辑
  let leftNavFunc = function () {
   $('#pageSidebarMenu').show();
   let tenantId = userInfo.tenantId || userInfo.ducpTenantId;
   let systemVersion = window.localStorage.getItem('systemVersion');
   let gateway_navs = JSON.parse(window.localStorage.getItem('gateway_navs')) || [];
   
   if (systemVersion === 'industry' && (tenantId !== '4091' && tenantId !== '1d2acfe5db6940f7b490b6f9cf91c85e' && tenantId !== '109')) {
     $('#pageSidebarMenu').html(
       '<li style="height: 60px; line-height: 60px;padding-left: 70px;color: #454e66;font-size:16px; ">门户首页</li>'
     );
     gateway_navs.map(navItem => {
       let iconName = 'industry';
       let navId = navItem.menuId.split('@')[0];
       switch (navId) {
         case 'gateway_home_page_industry':
           iconName = 'industry';
           break;
         case 'gateway_home_page_local':
           iconName = 'local';
           break;
         case 'gateway_home_page_nation':
           iconName = 'nation';
           break;
       }
       $('#pageSidebarMenu').append(`
         <li class="page-nav-item" id="${navId}">
           <a
             href="javascript:;"
             data-url="..${navItem.menuUrl}"
           >
             <svg class="icon icon-normal" aria-hidden="true">
               <use xlink:href="#icon-nav-${iconName}"></use>
             </svg>
             <svg class="icon icon-active" aria-hidden="true">
               <use xlink:href="#icon-nav-${iconName}2"></use>
             </svg>
             <span>${navItem.menuName}</span>
           </a>
         </li>
       `);
     });
   }

   //设置导航高亮
   (function highlightItem() {
     if (location.href.indexOf('home_page_industry') !== -1) {
       $('#pageSidebarMenu li#gateway_home_page_industry').addClass('active');
     } else if (location.href.indexOf('home_page_local') !== -1) {
       $('#pageSidebarMenu li#gateway_home_page_local').addClass('active');
     } else if (location.href.indexOf('home_page_nation') !== -1) {
       $('#pageSidebarMenu li#gateway_home_page_nation').addClass('active');
     } else {
       $('#pageSidebarMenu li#homePages').addClass('active');
     }
   })();
   //避免导航栏样式变化，延时显示
   setTimeout(function () {
     $('#pageSidebarMenu li')
       .show()
       .on('click', '>a', function () {
         let url = $(this).data('url');
         let timestamp = new Date().getTime();

         // 判断url是否存在，有则跳转，没有则提示
         if (url) {
           window.location.href = `${url}?timestamp=${timestamp}`;
         } else {
           alert('此导航没有跳转地址信息，请联系管理员处理');
         }
       });
   }, 100);
  };
  let fastLeftNavFunc = function () {
   $('#pageSidebarMenu').hide();
   let tenantId = userInfo.tenantId || userInfo.ducpTenantId;
   let systemVersion = window.localStorage.getItem('systemVersion');
   let gateway_navs = JSON.parse(window.localStorage.getItem('gateway_navs')) || [];

   if (
    tenantId === '4091' ||
    tenantId === '1d2acfe5db6940f7b490b6f9cf91c85e' ||
    tenantId === '109'
  ) {
    $(`#sysNav0`).append(
      `<div class="sys-nav-main">
       <ul class="page-navs">
        <li class="page-nav-item" id="socialHotspot">
          <a href="javascript:;" data-url="../social_hotspot/social_hotspot.html">
            <span>社会热点</span>
          </a>
        </li>
        <li class="page-nav-item" id="industryHotspot">
          <a href="javascript:;" data-url="../industry_hotspot/industry_hotspot.html">
            <span>公安热点</span>
          </a>
        </li>
        <li class="page-nav-item" id="historyHotspot">
          <a href="javascript:;" data-url="../history_hotspot/history_hotspot.html">
            <span>历史热点</span>
          </a>
        </li>
        <li class="page-nav-item" id="importantWork">
          <a href="javascript:;" data-url="../important_work/important_work.html">
            <span>重点工作</span>
          </a>
        </li>
        <li class="page-nav-item" id="mediaReport">
          <a href="javascript:;" data-url="../media_report/media_report.html">
            <span>媒体报道</span>
          </a>
        </li>
        <li class="page-nav-item" id="customMade">
          <a href="javascript:;" data-url="../custom_made/custom_made.html">
            <span>个性定制</span>
          </a>
        </li>
       </ul>
      </div>`
     );
  }else if(tenantId === '3705'){
    // 此租户进入complex页面，无需页面导航
  }else{
    $(`#sysNav0`).append(
      `<div class="sys-nav-main">
       <ul class="page-navs">
        <li class="page-nav-item active" id="homePage">
          <a href="javascript:;" data-url="../home_page/home_page.html">
            <span>本地/全国数据</span>
          </a>
        </li>
       </ul>
      </div>`
    );
  }
   
   if (systemVersion === 'industry' && (tenantId !== '4091' && tenantId !== '1d2acfe5db6940f7b490b6f9cf91c85e' && tenantId !== '109')) {
    $('#sysNav0 .page-navs').html('');
    gateway_navs.map(navItem => {
      let iconName = 'industry';
      let navId = navItem.menuId.split('@')[0];
      switch (navId) {
        case 'gateway_home_page_industry':
          iconName = 'industry';
          break;
        case 'gateway_home_page_local':
          iconName = 'local';
          break;
        case 'gateway_home_page_nation':
          iconName = 'nation';
          break;
      }
      $('#sysNav0 .page-navs').append(`
        <li class="page-nav-item" id="${navId}">
          <a
            href="javascript:;"
            data-url="..${navItem.menuUrl}"
          >
            <svg class="icon icon-normal" aria-hidden="true">
              <use xlink:href="#icon-nav-${iconName}"></use>
            </svg>
            <svg class="icon icon-active" aria-hidden="true">
              <use xlink:href="#icon-nav-${iconName}2"></use>
            </svg>
            <span>${navItem.menuName}</span>
          </a>
        </li>
      `);
    });
   }

   //设置导航高亮
   (function highlightItem() {
     if (location.href.indexOf('home_page_industry') !== -1) {
       $('#sysNav0 li#gateway_home_page_industry').addClass('active');
     } else if (location.href.indexOf('home_page_local') !== -1) {
       $('#sysNav0 li#gateway_home_page_local').addClass('active');
     } else if (location.href.indexOf('home_page_nation') !== -1) {
       $('#sysNav0 li#gateway_home_page_nation').addClass('active');
     } else if (location.href.indexOf('social_hotspot') !== -1) {
       $('#sysNav0 li#socialHotspot').addClass('active');
     } else if (location.href.indexOf('industry_hotspot') !== -1) {
       $('#sysNav0 li#industryHotspot').addClass('active');
     } else if (location.href.indexOf('history_hotspot') !== -1) {
       $('#sysNav0 li#historyHotspot').addClass('active');
     } else if (location.href.indexOf('important_work') !== -1) {
       $('#sysNav0 li#importantWork').addClass('active');
     } else if (location.href.indexOf('media_report') !== -1) {
       $('#sysNav0 li#mediaReport').addClass('active');
     } else if (location.href.indexOf('custom_made') !== -1) {
       $('#sysNav0 li#customMade').addClass('active');
     } else if (location.href.indexOf('complex') !== -1) {
      $('#sysNav0 li#complex').addClass('active');
    } else {
       $('#sysNav0 li#homePages').addClass('active');
     }
   })();
   //避免导航栏样式变化，延时显示
   setTimeout(function () {
     $('#sysNav0 li')
       .show()
       .on('click', '>a', function () {
         let url = $(this).data('url');
         let timestamp = new Date().getTime();

         // 判断url是否存在，有则跳转，没有则提示
         if (url) {
           window.location.href = `${url}?timestamp=${timestamp}`;
         } else {
           alert('此导航没有跳转地址信息，请联系管理员处理');
         }
       });
   }, 100);
  };

  // 不同的框架处理逻辑，普通版本normalFrame，智新版本fastFrame，智汇版本gatewayFrame
  var frames = {
    gatewayFrame: function gatewayFrame() {
      if(hideHeader){
        $('#pageHeader').css({height: 0, overflow: 'hidden'});
        $('.page-nav').css({top: 0,height: '100vh'});
        $('.page-main').css('margin-top', 0);
      }
      var blocks = JSON.parse(window.localStorage.getItem('blocks'));
      var gateway = new Gateway({
        currentAppid: 0,
        blocks: blocks,
        initHeader: true,
        headerSelector: '#pageHeader',
        sysNavSelector: '.page-nav',
        headerClassify,
      });
      gateway.init();
      if(userInfo.tenantId === '4091' || userInfo.ducpTenantId === '1d2acfe5db6940f7b490b6f9cf91c85e' || userInfo.tenantId === '109'){
        $('#firstPageSidebar').text('头条参考');
        $('#gatewaySysNavItem0').attr('title', '头条参考').find('a').html('<img src="//cdn.bigdata.cloud.dayang.com.cn/static/app-icon/sys-nav-index2.png" alt="无法加载">头条参考');
      }

      // 系统内页面导航
      leftNavFunc();
    },
    gatewayDucpFastFrame: function gatewayDucpFastFrame() {
      var fastBaseUrl = window.localStorage.getItem('fastAddress'); // //113.57.175.69:8087/gateway/
      var tenantId = userInfo.ducpTenantId || userInfo.localTenantId;// ducp的租户id 或者 cre的本地租户id

      if (!fastBaseUrl) {
        console.error('无快融实例根地址缓存，快融头将加载失败！');
        alert('快融实例根地址初始化异常，快融导航头将加载异常，建议登出重试！');

        this.gatewayFrame();
        return;
      }

      $('#pageHeader').addClass('page-wrapper-fast');

      // 快融头部样式渲染
      $.getScript(
        fastBaseUrl + 'dyportalweb/static/scripts/utils/headerPlugin.min.js',
        function () {
          $.initHeader(
            {
              userId: userInfo.userId,
              tenantId,
              token: userInfo.token,
              fastAddress: fastBaseUrl,
              divId: 'pageHeader',
              highLight: 'PID_Fast_MediaBigData',
              aboutInfo: [
                {
                  aboutName: '版本信息',
                  aboutCode: 'Vesion',
                  aboutValue: 'V1.0Build20190220',
                },
                {
                  aboutName: '升级时间',
                  aboutCode: 'UpdateTime',
                  aboutValue: '2019-02-20',
                },
              ],
            },
            function (loginModel, headerHeight) {
              // 加载css文件
              var portal_css =
                fastBaseUrl + 'dyportalweb/static/css/header.min.css';

              function loadStyles(url) {
                var link = document.createElement('link');
                link.type = 'text/css';
                link.rel = 'stylesheet';
                link.href = url;
                document.getElementsByTagName('head')[0].appendChild(link);
              }

              loadStyles(portal_css);

              // 获取头部高度，优先使用回调函数返回的头部高度，如果没有再获取指定id的高度
              if (headerHeight) {
                if (typeof headerHeight === 'string') {
                  headerHeight =
                    headerHeight.substring(0, headerHeight.length - 2) - 0;
                }
              } else {
                headerHeight = $('#portalHeaderDiv').height();
              }
              if (headerHeight === 110) {
                //对common.css文件中的样式进行选择
                $('#pageHeader').addClass('page-wrapper-fast-old');
              } else {
                //对common.css文件中的样式进行选择
                $('#pageHeader').addClass('page-wrapper-fast-new');

                //兼容更多自定义的高度
                $('#pageHeader').height(headerHeight);
                $('.page-nav').css('top', `${headerHeight}px`);
                $('.page-nav').css('height', `calc(100vh - ${headerHeight}px)`);
                $('.page-main').css('margin', `${headerHeight}px 20px 20px 220px`);
              }

              if(hideHeader){
                $('#pageHeader').css({height: 0, overflow: 'hidden'});
                $('.page-nav').css({top: 0,height: '100vh'});
                $('.page-main').css('margin-top', 0);
              }

              var blocks = JSON.parse(window.localStorage.getItem('blocks'));
              var gateway = new Gateway({
                currentAppid: 0,
                blocks: blocks,
                initHeader: false,
                headerSelector: '#pageHeader',
                sysNavSelector: '.page-nav',
                headerClassify,
              });
              gateway.init();

              if(tenantId === '4091' || tenantId === '1d2acfe5db6940f7b490b6f9cf91c85e' || tenantId === '109'){
                $('#firstPageSidebar').text('头条参考');
                $('#gatewaySysNavItem0').attr('title', '头条参考').find('a').html('<img src="//cdn.bigdata.cloud.dayang.com.cn/static/app-icon/sys-nav-index2.png" alt="无法加载">头条参考');
              }

              // 系统内页面导航
              fastLeftNavFunc();
            }
          );
        }
      );
    },
    gatewayCreFastFrame: function gatewayCreFastFrame() {
      // 目前该种形式的嵌入和ducp的嵌入一致
      this.gatewayDucpFastFrame();
    },
    gatewayCdvFastFrame: function gatewayCdvFastFrame() {
      // 目前该种形式的嵌入和ducp的嵌入一致
      this.gatewayDucpFastFrame();
    },
  };

  // 根据不同版本，初始化头部和左侧导航
  switch (headerClassify) {
    case 'gateway':
      frames.gatewayFrame();
      break;
    case 'gateway_ducp_fast':
      frames.gatewayDucpFastFrame();
      break;
    case 'gateway_cre_fast':
      frames.gatewayCreFastFrame();
      break;
    case 'gateway_cdv_fast':
      frames.gatewayCdvFastFrame();
      break;
  }

  //顶部搜索逻辑
  headerSearchFunc = function () {
    //搜索样式填充及处理逻辑
    var topSearch = function () {
      $('.page-header-search').html(
        '<div class="page-header-foldSearch">\n' +
          '  <i></i>\n' +
          '  <span>搜索</span>\n' +
          '</div>\n' +
          '<div class="page-header-unfoldSearch">\n' +
          '  <div class="search-content">\n' +
          '    <input type="text" autofocus placeholder="输入关键词搜索">\n' +
          '    <i></i>\n' +
          '    <span></span>\n' +
          '  </div>\n' +
          '  <div class="link-advanced-search"><i></i>筛选</div>\n' +
          '</div>'
      );
      $('.page-header-foldSearch').mouseenter(function () {
        $('.page-header-foldSearch').fadeOut();
        $('.page-header-unfoldSearch').fadeIn();
      });
      $('.page-header-unfoldSearch').mouseleave(function () {
        $('.page-header-foldSearch').fadeIn();
        $('.page-header-unfoldSearch').fadeOut();
      });
      // 点击搜索进入高级搜索页面
      function searchFunc(mode) {
        var searchContent = encodeURIComponent(
          $('.search-content input').val().trim()
        );
        let lastUrl = 'homePages';
        jumpToOtherSystem(
          'clue',
          hasClueService,
          cluePath,
          `/advancedSearch/advanced-search.html?lastUrl=${lastUrl}&searchContent=${searchContent}&mode=${mode}`,
          false
        );
      }
      $('.search-content span').click(function () {
        searchFunc();
      });
      //enter进入搜索页面
      $('.search-content input').on('keypress', function (e) {
        if (e.keyCode === 13) {
          searchFunc();
        }
      });
      // 点击“筛选条件”进入高级搜索页面的高级模式
      $('.link-advanced-search').on('click', function () {
        searchFunc('advanced');
      });
    };
    //根据权限判断是否拥有顶部搜索功能
    if (rightObj['newsbigdata_clue_advance_search']) {
      $('.page-header-search').show();
      topSearch();
    }
  };

  // 图片加载失败后的替代图片
  window.addEventListener(
    'error',
    function (e) {
      let target = e.target, // 当前dom节点
        parentNode = target.parentNode, // 父节点
        tagName = target.tagName;

      // 当前异常是由图片加载异常引起的
      if (tagName && tagName.toUpperCase() === 'IMG') {
        if ($(parentNode).hasClass('imgBox')) {
          parentNode.remove();
        } else {
          target.remove();
        }
      }
    },
    true
  );

  // 导航栏中消息提醒操作
  let initPanelMsg = function () {
    let msgParams = {
      client_type: 'bs',
      page_no: 1,
      page_size: 30,
    };

    let panelMsgList = [];

    // 请求-获取用户通知消息查询
    function checkPanelMsgs(params = msgParams) {
      return new Promise((res, rej) => {
        ajaxRequest({
          url: panelTipMsgUrl,
          type: 'get',
          async: true,
          data: params,
          success(data) {
            if (data.success) {
              let result = data.result || {};
              let resultList = result.list || [];

              // 处理列表
              let msgList = [];
              resultList.map(v => {
                msgList.push({
                  msgCreateTime: v.createTime,
                  ...v.msg,
                });
              });

              if (msgParams.page_no === 1) {
                panelMsgList = [...msgList];
              } else {
                panelMsgList = [...msgList, panelMsgList];
              }
              res(panelMsgList);
            } else {
              rej('获取通知消息失败');
            }
          },
        });
      });
    }

    $('.gateway-msg')
      .on('click', '.bell-box', function () {
        $('.gateway-msg-box').show();
      })
      .on(
        'click',
        '.gateway-msg-box .mask, .gateway-msg-header >.icon',
        function () {
          $('.gateway-msg-box').hide();
        }
      )
      .on('click', '.gateway-msg-item', function () {
        let panelId = $(this).data('panelId');
        let resourceId = $(this).data('resourceId');
        let originUrl = $(this).data('originUrl');

        if (resourceId) {
          jumpToOtherSystem(
            'clue',
            hasClueService,
            cluePath,
            `/panel/panel-detail.html?panelId=${panelId}&resourceId=${resourceId}`,
            true
          );
        } else {
          window.open(originUrl);
        }
      });
    function testNewsTime() {
      let currentTimeStamp = new Date().getTime();

      let hasRecentMsg = false;
      $('.gateway-msg-list .gateway-msg-item').map((i, v) => {
        let msgCreateTime = $(v).find('.msg-create-time').text();
        let msgCreateTimeStamp = new Date(msgCreateTime).getTime();

        if (currentTimeStamp - msgCreateTimeStamp <= 120000) {
          hasRecentMsg = true;
          $(v).addClass('recent-msg');
        } else if (currentTimeStamp - msgCreateTimeStamp <= 86400000) {
          $(v).removeClass('recent-msg');
        } else {
          let panelId = $(v).data('panelId');
          $(v).remove();
          panelMsgList.map((msg, index) => {
            if (msg.panelId === panelId) {
              panelMsgList.splice(index, 1);
            }
          });
        }
      });

      if (panelMsgList.length) {
        $('.gateway-no-msg').hide();
      } else {
        $('.gateway-no-msg').show();
      }

      if (hasRecentMsg) {
        $('.gateway-msg').addClass('active');
      }
    }
    websocket.on('connect', function () {
      checkPanelMsgs()
        .then(result => {
          panelMsgList.map(v => {
            $('.gateway-msg-list').append(
              `<li class="gateway-msg-item" data-panel-id="${v.panelId}" data-panel-name="${v.panelName}" data-resource-id="${v.resourceId}" data-origin-url="${v.originUrl}"><h4 class="omit-word">${v.title}</h4><div class="gateway-msg-info"><span class="msg-create-time">${v.msgCreateTime}</span><span>${v.mediaName}</span></div></li>`
            );
          });

          // 判断是否有近期消息
          setTimeout(() => {
            testNewsTime();
          }, 200);
        })
        .catch(errorMsg => {
          boxMessage('error', errorMsg);
        });
    });
    websocket.on('new_tip', function (data) {
      let msg = data.msg || {};

      panelMsgList.unshift({
        panelId: msg.panelId,
        panelName: msg.panelName,
        resourceId: msg.resourceId,
        originUrl: msg.originUrl,
        title: msg.title,
        mediaName: msg.mediaName,
        msgCreateTime: data.createTime,
      });
      $('.gateway-msg-list').prepend(
        `<li class="gateway-msg-item recent-msg" data-panel-id="${msg.panelId}" data-resource-id="${msg.resourceId}" data-origin-url="${msg.originUrl}"><h4 class="omit-word">${msg.title}</h4><div class="gateway-msg-info"><span class="msg-create-time">${data.createTime}</span><span>${msg.mediaName}</span></div></li>`
      );

      // 判断是否有近期消息
      setTimeout(() => {
        testNewsTime();
      }, 200);
    });
    setInterval(() => {
      testNewsTime();
    }, 10000);
  };
  initPanelMsg();
});

export {
  rightObj,
  rightErrorCode,
  limitErrorCode,
  hintType,
  rightHintWords,
  detailRightHintWords,
  limitHintWords,
  headerSearchFunc,
};
